import React, { useState } from "react";
import SponsorForm from "./form";
import SponsorList from "./list";

const SponsorPage = () => {
  const [refresh, setRefresh] = useState(false);

  const handleSuccess = () => {
    setRefresh((prev) => !prev);
  };

  return (
    <div className="">
      <h2 className="text-2xl font-bold mb-4">Sponsors Management</h2>
      
      <SponsorForm onSuccess={handleSuccess} />
      <SponsorList key={refresh} />
    </div>
  );
};

export default SponsorPage;